import Vue from "vue";

const eventBus = new Vue();

/*****************************
 * Register global listeners *
 *****************************/
//Open project event
eventBus.$on('project:open', projectId => {
console.log('project:open');
  const openProjectFunc = () => {
    const projectItemElement = document.getElementById('project-item-'+projectId);
    if (projectItemElement) {
      eventBus.$emit('project:show', projectId);
      console.log('project:show');
      setTimeout(() => {
        projectItemElement.scrollIntoView();
      }, 300);
    } else {
      setTimeout(openProjectFunc, 300);
    }
  };
  //Files component should listen project:open event and switch tab to projects
  //TODO: check current route and change location if user not on Files route
  console.log(projectId);
  if (projectId) {
    openProjectFunc();
  }
});

export default eventBus;
